/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The alert status of the ticket
 */
export enum TicketStatusAlert {
  NEW = 'new',
  IN_PROGRESS = 'in_progress',
  CLOSED = 'closed',
  ALL_OPEN = 'all_open',
  IN_TIME = 'in_time',
  IN_FOCUS = 'in_focus',
}
